import Icon from 'ui/components/Icon'

const ChecklistItemMenuActions = ({
  canCreateSubtask,
  onMoveUp,
  onMoveDown,
  onCopy,
  onCreateSubtask,
  onDelete,
  close,
}) => (
  <>
    <button
      type="button"
      onClick={() => {
        onMoveUp()
        close()
      }}
    >
      <Icon name="arrow-top" size={16} />
      <span>Переместить вверх</span>
    </button>
    <button
      type="button"
      onClick={() => {
        onMoveDown()
        close()
      }}
    >
      <Icon name="arrow-bottom" size={16} />
      <span>Переместить вниз</span>
    </button>
    <button
      type="button"
      onClick={() => {
        onCopy()
        close()
      }}
    >
      <Icon name="copy" size={16} />
      <span>Копировать</span>
    </button>
    {canCreateSubtask && (
      <button
        type="button"
        onClick={() => {
          onCreateSubtask()
          close()
        }}
      >
        <Icon name="create" size={16} />
        <span>Создать подзадачу</span>
      </button>
    )}
    <button
      type="button"
      onClick={() => {
        onDelete()
        close()
      }}
    >
      <Icon name="trash" size={16} />
      <span>Удалить</span>
    </button>
  </>
)

export default ChecklistItemMenuActions
